export default __webpack_public_path__ + "static/media/ears.0cc98f23.png";